import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import { getAllProdutos, getProdutoModulo, getProdutos } from "../queries/getProdutos";

export default function useGetProdutos(search?: string, page = 1) {
  const resultQuery = useQuery(
    [`${URLS.PRODUTOS_API}`, {
      params: { search, page }
    }],
    () => getProdutos(search, page)
  );

  return resultQuery;
}

export function useGetProduto(ProdutoId: number) {
  const resultQuery = useQuery([`${URLS.PRODUTOS_API}/${ProdutoId}`], () =>
    getProdutoModulo(ProdutoId)
  );

  return resultQuery;
}


export function useGetAllProdutos(search?: string) {
  const resultQuery = useQuery(
    search ? [`${URLS.PRODUTOS_API}`, {
      params: { search }
    }] : [URLS.PRODUTOS_API],
    () => getAllProdutos(search),
    {
      onSuccess: (data) => {
        // console.log(data);
        return data;
      },
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return resultQuery;
}
